module.exports = __webpack_public_path__ + "img/S6.1a04ff4e.png";